import { useState, useEffect } from "react";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import instance from "../../services/endpoint.js";
import { toast } from "react-toastify";
import UPIQRimg from "../../images/UPI-QR.jpg";

const DepositPage = () => {
  const [formData, setFormData] = useState({
    depositMode: "",
    amount: "",
    imageProof: null,
    withdrawPeriodSelected: "1", // Default to Yearly
  });
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  
  const handleSubmit = async (event) => {
    event.preventDefault();
    const { depositMode, amount, imageProof } = formData;

    if (!depositMode || !amount || !imageProof ) {
      toast.info("Please fill all required fields and upload proof.");
      return;
    }


    if (imageProof) {
      const fileType = imageProof.type;
      if (!["image/jpeg", "image/png", "image/jpg"].includes(fileType)) {
        toast.warning("Only JPEG, PNG and JPG files are allowed.");
        return;
      }
    }
    // File size check
    if (imageProof && imageProof.size > 10 * 1024 * 1024) {
      toast.error("File size exceeds 10MB limit.");
      return;
    }

    const submissionData = new FormData();
    submissionData.append("deposit_mode", depositMode);
    submissionData.append("amount", amount);
    submissionData.append("image_proof", imageProof);
    submissionData.append("withdraw_period", formData.withdrawPeriodSelected);

    setIsLoading(true);
    setLoading(true);
    try {
      const { data } = await instance.post("/api/v1/deposit", submissionData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(data.message);
      toast.success("Sent deposit request successfully");
      setFormData({
        depositMode: "",
        amount: "",
        imageProof: null,
        timePeriod: "",
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Something went wrong.";
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  const { depositMode, amount, imageProof, withdrawPeriodSelected } = formData;

  const renderPaymentDetails = () => {
    switch (depositMode) {
      case "Bank":
        return (
          <div className="payment-details-box">
            <p>Make Secure Payment with this Details</p>
            <p>Bank Name: SHAIK ADIL ZAMA</p>
            <p>Account Number: 5010227891331</p>
            <p>IFSC Code: HDFC0001998</p>
          </div>
        );
      case "UPI":
        return (
          <div className="payment-details-box">
            <div className="d-flex justify-content-between">
              <div>
                <p>Make Secure Payment with this Details</p>
                <p>UPI ID: adilrocks4ever.sr-5@okhdfcbank</p>
                <p>Account Holder: SHAIK ADIL ZAMA</p>
              </div>
              <div>
                <img
                  src={UPIQRimg}
                  alt="UPI QR Code"
                  style={{ width: "150px", height: "150px" }}
                />
              </div>
            </div>
          </div>
        );
      case "BTC":
        return (
          <div className="payment-details-box">
            <p>Make Secure Payment with this Details</p>
            <p>BTC Address: 1A1zP1eP5QGefi2DMPTfTL5SLmv7DivfNa</p>
          </div>
        );
      case "Netteller":
        return (
          <div className="payment-details-box">
            <p>Make Secure Payment with this Details</p>
            <p>Netteller Account: john.doe@example.com</p>
          </div>
        );
      case "ETH":
        return (
          <div className="payment-details-box">
            <p>Make Secure Payment with this Details</p>
            <p>ETH Wallet: 0x1234567890abcdef1234567890abcdef12345678</p>
          </div>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    document.title = "Deposit Payment | Bitstek Advisory";
  }, []);

  return (
    <>
      <Container className="custom-container">
        <h4 className="text-center text-primary mt-4">Deposit Payment</h4>
        <br />
        <Form onSubmit={handleSubmit}>
          <Row className="mb-2">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Mode of Payment</Form.Label>
                <Form.Select
                  name="depositMode"
                  value={depositMode}
                  onChange={handleChange}
                  required>
                  <option value="">Select</option>
                  <option value="Bank">Bank Transfer</option>
                  <option value="UPI">UPI</option>
                  <option value="BTC">BTC</option>
                  <option value="Netteller">Netteller</option>
                  <option value="ETH">ETH</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Enter Deposit Amount</Form.Label>
                <Form.Control
                  type="text"
                  inputMode="numeric"
                  name="amount"
                  value={amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      handleChange(e);
                    }
                  }}
                  placeholder="Enter Deposit Amount"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>Lock-in Period</Form.Label>
                <Form.Select
                  name="timePeriod"
                  // value={formData.timePeriod}
                  // onChange={handleChange}
                  required
                  disabled>
                  <option value="12">12 Months</option>
                </Form.Select>
                <p className="text-muted" style={{ fontSize: "0.75rem" }}>
                  Your deposit will be locked for this period. Please ensure you
                  understand the terms before proceeding to investment.
                </p>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>Returns withdraw Period (optional)</Form.Label>
                <Form.Select
                  name="withdrawPeriodSelected"
                  value={withdrawPeriodSelected}
                  onChange={handleChange}>
                  <option value="4">Quarterly</option>
                  <option value="2">Half-Yearly</option>
                  <option value="1" selected>Yearly</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <br />

          {depositMode && renderPaymentDetails()}

          <div
            className="d-flex justify-content-center"
            style={{ maxWidth: "650px", margin: "auto" }}>
            <div className="upload-box">
              <p>Upload Payment Proof</p>
              <p className="file-note">
                NOTE: Only (JPEG/PNG/JPG) file types are allowed and MAX size:
                10MB
              </p>
              <label className="drag-upload">
                Drag document here or <span className="browse">browse</span> to
                upload
                <input
                  type="file"
                  name="imageProof"
                  accept="image/jpeg, image/png, image/jpg"
                  onChange={handleChange}
                  className="file-input"
                />
              </label>
              {imageProof && (
                <p className="file-name">Selected: {imageProof.name}</p>
              )}
            </div>
          </div>
          <br />

          <div className="d-flex justify-content-center">
            <Button type="submit" className="search-btn" disabled={isLoading}>
              {isLoading ? "Depositing..." : "Submit"}
            </Button>
          </div>
        </Form>

        {message && (
          <div className="alert alert-info mt-3" role="alert">
            {message}
          </div>
        )}
      </Container>
    </>
  );
};

export default DepositPage;
